export const gameCardType = {
  eng: [
    { value: 'quiz', label: 'Quiz' },
    { value: 'musicQuiz', label: 'Music Quiz' },
    { value: 'virus', label: 'Virus' },
    { value: 'vaccine', label: 'Vaccine' },
    { value: 'fortune', label: 'Fortune' },
    { value: 'trump', label: 'Trump' },
    { value: 'fail', label: 'Fail' },
    { value: 'truth', label: 'Truth' },
    { value: 'dare', label: 'Dare' },
    { value: 'competition', label: 'Competition' },
  ],
};

export const availabilityGroup = {
  eng: [
    { value: 'for_party', label: 'For Party' },
    { value: 'exclusive', label: 'Exclusive' },
    { value: 'quiz', label: 'Quiz' },
    { value: 'music_quiz', label: 'Music quiz' },
    { value: '18+', label: '18+' },
    { value: 'draft', label: 'Draft' },
    { value: 'hidden', label: 'Hidden' },
    { value: 'free', label: 'Free' },
    { value: 'groupe1', label: 'Groupe 1' },
  ],
};

export const initialAnswersState = {
  eng: {
    answer1: '',
    answer2: '',
    answer3: '',
    answer4: '',
  },
  ru: {
    answer1: '',
    answer2: '',
    answer3: '',
    answer4: '',
  },
};
